import PageBody from "../PageBody";
import UserDetail from "../components/pages/users/UserDetail";

const ClientDetailPage = () => {
  return (
    <PageBody>
      <UserDetail />
    </PageBody>
  );
};

export default ClientDetailPage;
